
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/capsula",
      function () {
        return require("private-next-pages/capsula.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/capsula"])
      });
    }
  